export const performances = [
  {
    id: '2025-03-15-jeokbyeokga-gala',
    date: '2025-03-15',
    title: '적벽가 갈라',
    venue: '고양아람누리',
    city: '고양',
    description: '삼국지 적벽대전을 소재로 한 장대한 서사의 하이라이트를 감상하는 무대.',
  },
  {
    id: '2024-12-01-heungboga-wanchang',
    date: '2024-12-01',
    title: '흥보가 완창',
    venue: '국립국악원',
    city: '서울',
    description: '흥과 해학이 살아있는 흥보가의 전곡을 완창으로 선보이는 무대.',
  },
]; 